module.exports = __webpack_public_path__ + "media/src/images/abouts/items/stores/godiva-7ab8a393e06587efb4f9c2519b02333a.jpg";